module.exports = __webpack_public_path__ + "d664201f/img/verified-icon.f93bbc14.svg";